import { render, staticRenderFns } from "./InstrumentAssignment.vue?vue&type=template&id=9c4b30b8&scoped=true"
import script from "./InstrumentAssignment.vue?vue&type=script&lang=ts"
export * from "./InstrumentAssignment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4b30b8",
  null
  
)

export default component.exports